document.querySelectorAll( '.b-guide-video' ).forEach( ( block ) => {

	/////////////////////
	// BLOCK CODE HERE //
	/////////////////////
	const test = block.querySelector( '.test' );
	if( test ) {

		test.classList.add( 'red' );

	}

} );
